import React, { useState } from 'react';

/**
 * LearnBookmarkItem - Display a single bookmark.
 *
 * Features:
 * - Truncated content preview
 * - Click to expand full content
 * - Move to folder action
 * - Delete action
 * - Source project name display
 */
export default function LearnBookmarkItem({
  bookmark,
  onClick,
  onMove,
  onDelete,
  allFolders,
  currentFolderId
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showMoveMenu, setShowMoveMenu] = useState(false);

  const maxLength = 100;
  const isLong = bookmark.content.length > maxLength;
  const displayContent = isExpanded || !isLong
    ? bookmark.content
    : bookmark.content.substring(0, maxLength) + '...';

  const handleToggleExpand = () => {
    if (isLong) {
      setIsExpanded(!isExpanded);
    }
    onClick?.();
  };

  const handleMove = (folderId) => {
    onMove(folderId);
    setShowMoveMenu(false);
  };

  return (
    <div className={`learn-bookmark-item ${isExpanded ? 'learn-bookmark-item--expanded' : ''}`}>
      <div className="learn-bookmark-item__content" onClick={handleToggleExpand}>
        {displayContent}
      </div>

      <div className="learn-bookmark-item__meta">
        {bookmark.source_project_name && (
          <span className="learn-bookmark-item__source">
            From: {bookmark.source_project_name}
          </span>
        )}
      </div>

      <div className="learn-bookmark-item__actions">
        <div className="learn-bookmark-item__move-container">
          <button
            className="learn-bookmark-item__action-btn"
            onClick={() => setShowMoveMenu(!showMoveMenu)}
            title="Move to folder"
          >
            📁
          </button>

          {showMoveMenu && (
            <div className="learn-bookmark-item__move-menu">
              <button
                className={!currentFolderId ? 'active' : ''}
                onClick={() => handleMove(null)}
              >
                Uncategorized
              </button>
              {allFolders.map(folder => (
                <button
                  key={folder.id}
                  className={folder.id === currentFolderId ? 'active' : ''}
                  onClick={() => handleMove(folder.id)}
                  disabled={folder.id === currentFolderId}
                >
                  {folder.name}
                </button>
              ))}
            </div>
          )}
        </div>

        <button
          className="learn-bookmark-item__action-btn learn-bookmark-item__action-btn--delete"
          onClick={onDelete}
          title="Delete bookmark"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
